export enum DevPortalNavEntryPoint {
  FulfillmentTestingCenter = 'fulfillment-testing-center',
  WebhookConfiguration = 'webhook-configuration',
}
